<div class="home-wrapper">

  <button mat-stroked-button (click)="startVisit()">
    {{'i18n.startVisit' | translate}}
  </button>

  <span class="app-version">{{appVersion}}</span>

</div>
